import { assign, pick } from 'lodash';

export class InspectionRepairItemForm {
  HANDLED_ATTRIBUTES = ['description', 'repair_issue', 'account', 'required'];

  constructor(inspectionRepairItem) {
    this.HANDLED_ATTRIBUTES.forEach(attr => {
      this[attr] = inspectionRepairItem ? inspectionRepairItem[attr] : null;
    });
  }

  // used for UI user actions
  handleAccountChange = account => {
    if (this.account !== account) {
      this.repair_issue = null;
      this.account = account;
    }
  }

  // used for UI user actions
  handleRepairIssueChange = repairIssue => {
    if (this.repair_issue !== repairIssue) {
      this.repair_issue = repairIssue;
    }
  }

  toInspectionRepairItem(iri) {
    assign(iri, pick(this, this.HANDLED_ATTRIBUTES));
  }
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/inspections/inspection-repair-item-form.js
 **/